import { type ComputedRef, computed } from "vue";
import { type Identity, useSessionState } from "./session";

/**
 * What this session is allowed to do, by role.
 *
 * The server decides — `RolesGuard` refuses with 403 whatever this lets through
 * by mistake. This exists so the panel does not offer a button that will fail,
 * and so a typed address does not land on a screen of empty panels.
 */
export type Role = Identity["role"];

/**
 * The rank order, duplicated on purpose: the front cannot import from the back.
 * The one that governs is `identity/domain/role.ts:15` — change both together.
 */
const RANK: Record<Role, number> = { member: 1, admin: 2, owner: 3 };

export function can(min: Role): boolean {
	const role = useSessionState().identity.value?.role;
	return role ? RANK[role] >= RANK[min] : false;
}

/** The same answer, reactive, for a `v-if`. */
export function useCan(min: Role): ComputedRef<boolean> {
	return computed(() => can(min));
}
